import { render } from "./StarRenderer.vue?vue&type=template&id=f8d5aa36&scoped=true"
import script from "./StarRenderer.vue?vue&type=script&lang=js"
export * from "./StarRenderer.vue?vue&type=script&lang=js"

import "./StarRenderer.vue?vue&type=style&index=0&id=f8d5aa36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8d5aa36"],['__file',"src/components/StarRenderer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f8d5aa36"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f8d5aa36', __exports__)) {
    api.reload('f8d5aa36', __exports__)
  }
  
  module.hot.accept("./StarRenderer.vue?vue&type=template&id=f8d5aa36&scoped=true", () => {
    api.rerender('f8d5aa36', render)
  })

}


export default __exports__